<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/image']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'image_common_name' | translate"></nz-statistic>
    </a>
</nz-card>